<p-dialog
  header="Editar Cargo"
  [(visible)]="visible"
  [modal]="true"
  (onHide)="closeDialog()"
  [closable]="true"
  [style]="{ width: '25%', height: '43vh' }"
>
  <div class="loading-spinner" *ngIf="isLoading">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
  </div>
  
  <div class="flex flex-column gap-3 mb-3" *ngIf="!isLoading">
    <div class="field">
      <label for="area" class="font-semibold">Área</label>
      <p-autoComplete
        id="area"
        [(ngModel)]="selectedArea"
        [suggestions]="filteredOptions"
        (completeMethod)="filterOptions($event, 'area')"
        (input)="onChangeInput($event, 'area')"
        [dropdown]="true"
        [disabled]="true"
        [forceSelection]="true"
        [placeholder]="'Selecciona un área...'"
        (onSelect)="onSelect($event, 'area')"
        [style]="{ width: '100%' }"
        [field]="'text'"
      ></p-autoComplete>
      <div
        *ngIf="!selectedArea && hasInteracted['area']"
        class="error-message"
        style="color: red; font-size: 0.875rem; margin-top: 5px"
      >
        Este campo es obligatorio.
      </div>
    </div>
    <br />

    <div class="field">
      <label for="jobPosition" class="font-semibold">Cargo</label>
      <input
        pInputText
        id="jobPosition"
        type="text"
        [(ngModel)]="jobPosition"
        (ngModelChange)="onChangeInput($event, 'jobPosition')"
        [placeholder]="'Ingresa nombre del cargo'"
      />
      <div
        *ngIf="!jobPosition && hasInteracted['jobPosition']"
        style="color: red; font-size: 0.875rem; margin-top: 5px"
      >
        Este campo es obligatorio.
      </div>
    </div>
  </div>

  <div
    style="display: flex; justify-content: center; gap: 10px; margin-top: 10px"
  >
    <button
      type="button"
      pButton
      label="Guardar cambios"
      [disabled]="isDisabled"
      (click)="onSaveChanges()"
      class="btn"
    ></button>
  </div>
</p-dialog>
